import React from 'react'
import ReactDOM from 'react-dom/client'
import { EmbedApp } from './App'
import { DistriConfig } from './types'
import './index.css'

const Distri = {
  init: (config: DistriConfig) => {
    (window as any).distriConfig = config;

    const rootElement = document.getElementById('root');
    if (rootElement) {
      ReactDOM.createRoot(rootElement).render(
        <React.StrictMode>
          <EmbedApp />
        </React.StrictMode>,
      )
    }
  }
};

(window as any).Distri = Distri;

// Process queue if it exists
const q = (window as any).Distri?.q || [];
if (Array.isArray(q)) {
  q.forEach((item: any) => {
    if (Array.isArray(item) && item[0] === 'init') {
      Distri.init(item[1]);
    }
  });
}

// Auto-initialize for iframe usage
const params = new URLSearchParams(window.location.search);
if (!(window as any).distriConfig && params.has('clientId')) {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <EmbedApp />
      </React.StrictMode>,
    )
  }
}
